var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { BNav, BNavItem, BButton, BIconBoxArrowRight, BIconChevronDown, BIconFileEarmarkPlus } from 'bootstrap-vue';
import UserAvatar from '@/modules/main/components/UserAvatar.vue';
import Login from '@/modules/main/components/Login.vue';
import Logout from '@/modules/main/components/Logout.vue';
import Badge from '@/modules/main/components/Badge.vue';
import Register from '@/modules/main/components/Register.vue';
var UserBar = /** @class */ (function (_super) {
    __extends(UserBar, _super);
    function UserBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.staticSection = ['fuerenand', 'belvita', 'login', ''];
        return _this;
    }
    Object.defineProperty(UserBar.prototype, "userIsLoggedIn", {
        get: function () {
            return !!this.currentUser.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserBar.prototype, "currentUser", {
        get: function () {
            return this.user || this.session.user;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserBar.prototype, "userFullName", {
        get: function () {
            var _a, _b;
            return ((_a = this.currentUser) === null || _a === void 0 ? void 0 : _a.first_name) + " " + ((_b = this.currentUser) === null || _b === void 0 ? void 0 : _b.last_name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserBar.prototype, "notificationsCount", {
        get: function () {
            if (this.session.user) {
                return this.session.user.unread_notification_count;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserBar.prototype, "notificationsButtonLabel", {
        get: function () {
            return this.$t('notifications.barTitle') + " (" + this.notificationsCount + ")";
        },
        enumerable: false,
        configurable: true
    });
    UserBar.prototype.toggleNotifications = function () {
        this.$root.$emit('toggleNotifications');
    };
    Object.defineProperty(UserBar.prototype, "isStaticPage", {
        get: function () {
            return this.staticSection.includes(window.location.pathname.split('/')[1]);
        },
        enumerable: false,
        configurable: true
    });
    UserBar.prototype.onMenuItemClick = function () {
        this.$root.$emit('hideShowMenuClass');
    };
    __decorate([
        Inject(),
        __metadata("design:type", Object)
    ], UserBar.prototype, "session", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], UserBar.prototype, "user", void 0);
    UserBar = __decorate([
        Component({
            components: {
                BIconChevronDown: BIconChevronDown,
                BNav: BNav,
                BNavItem: BNavItem,
                BButton: BButton,
                BIconBoxArrowRight: BIconBoxArrowRight,
                BIconFileEarmarkPlus: BIconFileEarmarkPlus,
                UserAvatar: UserAvatar,
                Login: Login,
                Logout: Logout,
                Badge: Badge,
                Register: Register,
            },
        })
    ], UserBar);
    return UserBar;
}(Vue));
export default UserBar;
